module.exports = __webpack_public_path__ + "static/media/8.5b27b3b8.png";